// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2iMyN","label":"LabeledBox_label__3FCs0"};